import '@mdi/font/css/materialdesignicons.css'
import _ from 'lodash'
import Vue from 'vue'
import Vuetify from 'vuetify'
import th from 'vuetify/lib/locale/th'
import { importAll } from '@/assets/js/utils/svg-loader'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { th },
    current: 'th'
  },
  icons: {
    values: _.assign(
      importAll(
        require.context('@/assets/svg/icons/', true, /\.svg$/),
        'snt'
      ),
      importAll(
        require.context('@/assets/svg/banks', true, /\.svg$/),
        'bank'
      )
    )
  },
  theme: {
    light: true,
    dark: false,
    themes: {
      light: {
        'primary': '#1BA7E1',
        'secondary': '#6C6C6C',
        'error': '#DE6B4F',
        'success': '#19C788',
        'warning': '#F5BF54',
        'background': '#F4F6FA',
        'shopee': '#F8551F',
        'lazada': '#0304B0',
        'facebook': '#2669EA',
        'line': '#12bd13',
        'instagram': '#bb3886',
        'field-grey': '#B5B5B5',
        'topic-background': '#F6F6F6',
        'select': '#E7F4FC',
        'stroke-grey': '#E7E7E7',
        'primary-light': '#E7F4FC',
        'warning-light': '#FFF4DE',
        'error-light': '#FCE6E1',
        'error-light-2': '#F8BFB1',
        'success-light': '#DFF1EB'
      },
      dark: {
        primary: '#1BA7E1',
        error: '#F04D4D',
        success: '#2AB59C',
        warning: '#F5BF54',
        secondary: '#FFFFFF'
      }
    },
    options: {
      customProperties: true
    }
  }
})
